import { Component, input, output } from '@angular/core';
import { NzIconModule } from 'ng-zorro-antd/icon';
import { NzUploadFile, NzUploadModule } from 'ng-zorro-antd/upload';

@Component({
  selector: 'ui-upload',
  imports: [NzUploadModule, NzIconModule],
  templateUrl: './upload.html',
  styleUrl: './upload.scss',
})
export class UiUploadComponent {
  title = input('Click or drag file to this area to upload');
  subtitle = input('Support for a single upload.');
  accept = input('.csv,.xlsx,.xls');
  multiple = input(false);
  disabled = input(false);

  filesSelected = output<File[]>();

  protected readonly beforeUpload = (file: NzUploadFile): boolean => {
    const originFile = file as unknown as File & { originFileObj?: File };
    const selected = originFile.originFileObj ?? originFile;
    this.filesSelected.emit([selected]);
    return false;
  };
}
